module.exports = __webpack_public_path__ + "img/bg.49587dba.jpg";